// 操作の入力: キーボード(WASD・矢印)、ゲームパッドの左スティック、タッチ(画面のどこでも、触れた所からのずれで動く)。
// 試合へ渡すのは移動の向き { mx, my }(−100〜100 の整数)だけ。攻撃は自動。

export function createInput(target) {
  const keys = new Set();
  window.addEventListener("keydown", (e) => keys.add(e.code));
  window.addEventListener("keyup", (e) => keys.delete(e.code));
  window.addEventListener("blur", () => keys.clear());

  // タッチ: 触れた所を中心にした見えないスティック
  const stickEl = document.getElementById("stick");
  const knobEl = document.getElementById("stick-knob");
  const RADIUS = 56; // px。ここまでずらすと全速
  let touch = null; // { id, ox, oy, x, y }
  target.addEventListener(
    "pointerdown",
    (e) => {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      touch = { id: e.pointerId, ox: e.clientX, oy: e.clientY, x: e.clientX, y: e.clientY };
      if (stickEl) {
        stickEl.style.display = "block";
        stickEl.style.left = `${e.clientX}px`;
        stickEl.style.top = `${e.clientY}px`;
      }
      target.setPointerCapture?.(e.pointerId);
    },
    { passive: true }
  );
  target.addEventListener(
    "pointermove",
    (e) => {
      if (!touch || e.pointerId !== touch.id) return;
      touch.x = e.clientX;
      touch.y = e.clientY;
    },
    { passive: true }
  );
  const end = (e) => {
    if (!touch || e.pointerId !== touch.id) return;
    touch = null;
    if (stickEl) stickEl.style.display = "none";
  };
  target.addEventListener("pointerup", end);
  target.addEventListener("pointercancel", end);

  function sample() {
    let x = 0;
    let y = 0;
    if (keys.has("KeyA") || keys.has("ArrowLeft")) x -= 1;
    if (keys.has("KeyD") || keys.has("ArrowRight")) x += 1;
    if (keys.has("KeyW") || keys.has("ArrowUp")) y += 1;
    if (keys.has("KeyS") || keys.has("ArrowDown")) y -= 1;
    const pads = navigator.getGamepads ? navigator.getGamepads() : [];
    for (const pad of pads) {
      if (!pad) continue;
      const [ax, ay] = pad.axes;
      if (Math.hypot(ax, ay) > 0.18) {
        x += ax;
        y -= ay;
      }
    }
    if (touch) {
      let dx = (touch.x - touch.ox) / RADIUS;
      let dy = -(touch.y - touch.oy) / RADIUS;
      const len = Math.hypot(dx, dy);
      if (len > 1) {
        // 指が離れすぎたら、スティックの中心を指に付いてこさせる
        touch.ox = touch.x - (dx / len) * RADIUS;
        touch.oy = touch.y + (dy / len) * RADIUS;
        dx /= len;
        dy /= len;
        if (stickEl) {
          stickEl.style.left = `${touch.ox}px`;
          stickEl.style.top = `${touch.oy}px`;
        }
      }
      if (knobEl) knobEl.style.transform = `translate(${dx * RADIUS}px, ${-dy * RADIUS}px)`;
      x += dx;
      y += dy;
    }
    const len = Math.hypot(x, y);
    if (len > 1) {
      x /= len;
      y /= len;
    }
    return { mx: Math.round(x * 100), my: Math.round(y * 100) };
  }

  return { sample, pressed: (code) => keys.has(code) };
}
